import {
    Column,
    FacebookShareButton,
    Row,
    TwitterShareButton
} from "../../components";
import { UiSocialShareModel } from "../../models";

export type UiSocialShareProps = {
    readonly model: UiSocialShareModel;
};

const UiSocialShare = ({
    model: {
        id,
        type,
        content: { text, facebookButtonText, twitterButtonText, hashtags }
    }
}: UiSocialShareProps) => {
    return (
        <Row>
            <Column xs={{ top: "tight", bottom: "tight" }} sm={{ span: "6" }}>
                <FacebookShareButton
                    block={true}
                    buttonText={facebookButtonText}
                    uuid={id}
                    type={type}
                />
            </Column>
            <Column xs={{ top: "tight", bottom: "tight" }} sm={{ span: "6" }}>
                <TwitterShareButton
                    block={true}
                    buttonText={twitterButtonText}
                    message={text}
                    hashtags={hashtags}
                    uuid={id}
                    type={type}
                />
            </Column>
        </Row>
    );
};

export default UiSocialShare;
